import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from 'src/app/core/config/configuration.service';

@Injectable()
export class TestsProxy {
    constructor(private http: HttpClient, private configurationService: ConfigurationService) {}

    async get(practiceId: string): Promise<TestSummaryDTO[]> {
        const url = this.configurationService.APIURL + '/api/tests';
        let params = new HttpParams();
        params = params.append('practiceId', practiceId);
        return await this.http.get<TestSummaryDTO[]>(url, { params: params }).toPromise();
    }

    async getStandardCurveParameters(): Promise<StandardCurveParameterGroupDTO[]> {
        const url = this.configurationService.APIURL + '/api/tests/standardCurveParameters';
        let params = new HttpParams();
        return await this.http.get<StandardCurveParameterGroupDTO[]>(url, { params: params }).toPromise();
    }

    async updateStandardCurveParameters(updateStandardCurveParametersDTO: UpdateStandardCurveParametersDTO) {
        const url = this.configurationService.APIURL + '/api/tests/standardCurveParameters';
        await this.http.put(url, updateStandardCurveParametersDTO).toPromise();
    }
}

export interface TestSummaryDTO {
    reference: string;
    name: string;
    shortCode: string;
    primaryColorHex: string;
    secondaryColorHex: string;
    hyperLink: string;
    description: string;
    descriptionShort: string;
    iconSVG: string;
    testForm: TestFormDTO;
}

export interface TestFormDTO {
    maxNumberOfSamples: number;
    questions: TestQuestionDTO[];
}

export interface TestQuestionDTO {
    type: QuestionType;
    key: string;
    hint?: string;
    options?: { key: string; label: string }[];
}

export enum QuestionType {
    SelectSingle = 0,
    SelectMultiple = 1,
    YesNo = 2,
    Text = 3,
    Number = 4,
    TextArea = 5,
}

export interface StandardCurveParameterGroupDTO {
    testGroupKey: string;
    tests: {
        reference: string;
        name: string;
        primaryColorHex: string;
        secondaryColorHex: string;
    }[];
    targets: {
        key: string;
        slope: number;
        intercept: number;
        auditTrails: {
            user: string;
            timestamp: string;
            oldSlope: number;
            oldIntercept: number;
        }[];
    }[];
}

export interface UpdateStandardCurveParametersDTO {
    testGroupKey: string;
    targetKey: string;
    slope: number;
    intercept: number;
}
